import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTRSCluster } from 'API/TRSCluster/createTRSCluster';

const useCreateTRSCluster = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const createCluster = async (clusterData) => {
        try {
            const response = await createTRSCluster(clusterData);
            return response.data;
        } catch (error) {
            console.error('Error creating TRS cluster:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: createCluster,
        onSuccess: (data) => {
            // Invalidate and refetch the clusters list
            queryClient.invalidateQueries({ queryKey: ['TRSClusters'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateTRSCluster;
